import { useContext } from 'react';
import { TeamContext } from 'contexts/team_context';

const useTeam = () => {
    return useContext(TeamContext);
};

export default useTeam;
